export default __webpack_public_path__ + "static/media/dark-logo.d940b682.svg";